import React from 'react';
import './HowToUse.css';

const HowToUse = () => {
  const steps = [
    { number: 1, title: 'Download LunarLog AI', description: 'Install our trading journal app from the App Store' },
    { number: 2, title: 'Set Up Your Account', description: 'Create your profile and customize your trading preferences' },
    { number: 3, title: 'Record Your Trades', description: 'Use voice-to-text to naturally describe your trades' },
    { number: 4, title: 'Get AI Insights', description: 'Receive detailed analysis and performance metrics' },
    { number: 5, title: 'Track & Improve', description: 'Monitor your progress and refine your trading strategy' }
  ];

  return (
    <section className="how-to-use section-padding">
      <div className="container">
        <h2 className="section-title">Getting Started</h2>
        <p className="section-subtitle">Begin your trading journey in 5 simple steps</p>
        
        <div className="steps-detailed">
          {steps.map((step, index) => (
            <div key={index} className="step-detailed">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToUse;
